import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Toaster } from 'react-hot-toast';

import clsx from 'clsx';

import { AppDispatch } from '../../../redux/reducer/store';

import { actionGetApplicationsList, actionApplicationFilters, actionTest } from '../../../redux/action/recruiting/actionApplicationForm';

import { reducerSelectedApplicationsId, reducerApplicationsListInputValues, reducerSingleApplicationMultiSelect } from '../../../redux/reducer/recruiting/reducers/reducerApplicationForm';

import { formatDateWithDots } from '../../../utils/formatDate';
import { formatReports } from '../../../utils/formatReports';

import Loader from '../../custom/loader/loader';

import "../table.scss";

import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import RangeDatePicker from '../../custom/rangeDatePicker/rangeDatePicker';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import Pagination from '../../pagination/pagination';


const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableApplicationFormList: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { data, limit, page, count, checkboxes, selectedApplicationsId, applicationListInputValues, filters, modifiedDate } = useSelector(
		(state: any) => state.recruiting.applicationsList
	);
	const { isOpenSidebar } = useSelector((state: any) => state.user.user);
	const { claims } = useSelector((state: any) => state.user.user.data);

	const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] =
		useState<boolean>(false);
	const [isCheckedRows, setIsCheckedRows] = useState<any>(checkboxes);
	const [currentPage, setCurrentPage] = useState(1);
	const [startPage, setStartPage] = useState(1);
	const [isInputChange, setIsInputChange] = useState<boolean>(false);
	const [isPending, setIsPending] = useState<boolean>(false);

	const actualLimit =
		JSON.parse(localStorage.getItem('pageLimit') as string) || limit;

	const detectedBasename = window.location.pathname.startsWith('/react')
		? '/react'
		: '';
		useEffect(() => {
			if (selectedApplicationsId && !selectedApplicationsId.length) {
				setIsCheckedRows(data && checkboxes);
				setIsHeaderCheckboxChecked(false);
			}
		}, [checkboxes, data, selectedApplicationsId]);
	

	useEffect(() => {
		if (data) {
			const updatedCheckedRows =
				data &&
				data.reduce((acc: any, vacancy: any) => {
					const vacancyId = vacancy.application?.id;
					acc[vacancyId] = false;
					return acc;
				}, {});
			dispatch(reducerSelectedApplicationsId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
	}, [dispatch, data]);

	useEffect(() => {
		if (isHeaderCheckboxChecked && data) {
			const updatedCheckedRows =
				data &&
				data.reduce((acc: any, vacancy: any) => {
					const vacancyId = vacancy.application?.id;
					acc[vacancyId] = isHeaderCheckboxChecked ? true : false;
					return acc;
				}, {});
			dispatch(reducerSelectedApplicationsId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
	}, [dispatch, isHeaderCheckboxChecked, data]);

	const handleHeaderCheckboxChange = () => {
		setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
		if (isHeaderCheckboxChecked) {
			const updatedCheckedRows =
				data &&
				data.reduce((acc: any, vacancy: any) => {
					const vacancyId = vacancy.application?.id;
					acc[vacancyId] = false;
					return acc;
				}, {});
			dispatch(reducerSelectedApplicationsId(formatReports(updatedCheckedRows)));
			setIsCheckedRows(updatedCheckedRows);
		}
	};

	const handleRowCheckboxChange = (el: any) => {
		const applicationId = el?.application?.id;
		setIsCheckedRows((prevCheckedRows: any) => ({
			...prevCheckedRows,
			[applicationId]: !prevCheckedRows[applicationId],
		}));

		const updatedSelectedVacancies = formatReports({
			...isCheckedRows,
			[applicationId]: !isCheckedRows[applicationId],
		});

		dispatch(reducerSelectedApplicationsId(updatedSelectedVacancies));
		if (updatedSelectedVacancies.length === data.length) {
			setIsHeaderCheckboxChecked(true);
		} else {
			setIsHeaderCheckboxChecked(false);
		}
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = event.target;
		if (value === '') {
			const updatedInputValues = { ...applicationListInputValues };
			delete updatedInputValues[name];
			dispatch(reducerApplicationsListInputValues(updatedInputValues));
		} else {
			dispatch(
				reducerApplicationsListInputValues({ ...applicationListInputValues, [name]: value })
			);
		}
		setIsInputChange(true);
	};

	const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter') {
			setIsPending(true);
			dispatch(actionGetApplicationsList(limit, page)).then(() => {
				setIsPending(false);
			});
			setIsInputChange(false);
			resetPages();
		}
	};

	const handleChange = (newLimit: number, newPage: number) => {
		setIsPending(true);
		dispatch(actionGetApplicationsList(newLimit, newPage)).then(() => {
			setIsPending(false);
		});
		localStorage.setItem('pageLimit', JSON.stringify(newLimit));
	};

	const resetPages = () => {
		setCurrentPage(1);
		setStartPage(1);
	};

	const handleChangeLimits = (option: any) => {
		handleChange(option.value, 1);
		resetPages();
	};

	useEffect(() => {
		setIsPending(true);
		dispatch(actionGetApplicationsList(limit, page)).then(() => {
			setIsPending(false);
		})
	}, [dispatch, limit, page])

	useEffect(() => {
		const handleDocumentClick = () => {
			setIsPending(true);
			dispatch(actionGetApplicationsList(limit, page)).then(() => {
				setIsPending(false);
			});
			setIsInputChange(false);
			resetPages();
		};

		if (isInputChange) {
			document.addEventListener('click', handleDocumentClick);

			return () => {
				document.removeEventListener('click', handleDocumentClick);
			};
		} else
			return () => {
				document.removeEventListener('click', handleDocumentClick);
			};
	}, [dispatch, isInputChange, limit, page]);

	const getRowClassName = (application: any) => {
		const statusObject = application?.applicantStatus;

		if (statusObject) {
			const statusKey = Object.keys(statusObject)[0];

			if (statusKey === 'REJECT_MANAGER') {
				return "red__row";
			} else if (statusKey === 'ON_PROJECT') {
				return "lightGreen__row";
			}
		}

		return "";
	};
	useEffect(() => {
		dispatch(actionApplicationFilters())

	}, [dispatch])
	return (
		<>
			<div className='loader__wrapper'>
				{(isPending) && <Loader />}
			</div>

			<div
				className={clsx(
					JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
					isOpenSidebar &&
					'active__table',
					!isOpenSidebar && 'closed__table',
					'table'
				)}
			>
				<Toaster position='top-center' toastOptions={{ duration: 5000 }} />

				<div className='table__wrapper'>
					<table>
						<thead>
							<tr>
								<th className='reports__checkbox_block'>
									<input
										onChange={handleHeaderCheckboxChange}
										checked={isHeaderCheckboxChecked}
										type='checkbox'
									/>
								</th>

								<th style={{ minWidth: '280px' }}>
									<div className='filter__block'>
										<input
											onChange={handleInputChange}
											onKeyPress={handleKeyPress}
											name='lastName'
											placeholder=' '
											type='text'
										/>
										<label>Фамилия</label>
									</div>
								</th>

								{(claims.includes('admin') || claims.includes('projects:list')) && <th>
									<div className='multiselect__filter_block'>
										<CustomMultiSelect
											setLoading={setIsPending}
											inputValues={applicationListInputValues}
											isShowPlaceholder={true}
											pageName='userReports'
											placeholder='Проект'
											name='projects'
											limit={limit}
											options={filters.projects}
											resetPages={() => { }}
											action={actionGetApplicationsList}
											reducer={reducerSingleApplicationMultiSelect}
										/>
									</div>
								</th>}

								<th style={{ minWidth: '280px' }}>
									<div className='filter__block'>
										<input
											onChange={handleInputChange}
											onKeyPress={handleKeyPress}
											name='login'
											placeholder=' '
											type='text'
										/>
										<label>Логин/Локация</label>
									</div>
								</th>

								<th style={{ minWidth: '180px' }}>
									<div className='filter__block'>
										<input
											onChange={handleInputChange}
											onKeyPress={handleKeyPress}
											name='vacancyName'
											placeholder=' '
											type='text'
										/>
										<label>Название вакансии</label>
									</div>
								</th>

								<th style={{ minWidth: '100px' }}>
									<div className='filter__block'>
										<input
											onChange={handleInputChange}
											onKeyPress={handleKeyPress}
											name='city'
											placeholder=' '
											type='text'
										/>
										<label>Город</label>
									</div>
								</th>

								<th style={{ minWidth: '100px' }}>
									<div className='filter__block'>
										<input
											onChange={handleInputChange}
											onKeyPress={handleKeyPress}
											name='phone'
											placeholder=' '
											type='number'
										/>
										<label>№ телефона соискателя</label>
									</div>
								</th>

								<th>
									<div className='multiselect__filter_block'>
										<CustomMultiSelect
											setLoading={setIsPending}
											inputValues={applicationListInputValues}
											isShowPlaceholder={true}
											pageName='userReports'
											placeholder='Статус кандидата'
											name='status'
											limit={limit}
											options={filters.statuses}
											resetPages={() => { }}
											action={actionGetApplicationsList}
											reducer={reducerSingleApplicationMultiSelect}
										/>
									</div>
								</th>

								<th>
									<div className='multiselect__filter_block'>
										<CustomMultiSelect
											setLoading={setIsPending}
											inputValues={applicationListInputValues}
											isShowPlaceholder={true}
											pageName='userReports'
											placeholder='Состояние кандидата'
											name='applicantCondition'
											limit={limit}
											options={filters.applicantCondition}
											resetPages={() => { }}
											action={actionGetApplicationsList}
											reducer={reducerSingleApplicationMultiSelect}
										/>
									</div>
								</th>

								<th >
									<div>
										<RangeDatePicker
											defaultDateFrom={modifiedDate.from}
											setLoading={setIsPending}
											reducer={reducerApplicationsListInputValues}
											inputValues={applicationListInputValues}
											defaultDateTo={modifiedDate.to}
											setCurrentPage={setCurrentPage}
											action={actionGetApplicationsList}
											setStartPage={setStartPage}
											limit={limit}
											page={page}
											placeholder={'Дата изменения'}
											pageName={'applicationList'}
										/>
									</div>
								</th>

								<th>
									<div className='multiselect__filter_block'>
										<CustomMultiSelect
											setLoading={setIsPending}
											inputValues={[]}
											isShowPlaceholder={true}
											pageName='userReports'
											placeholder='Созданный сотрудник'
											name='projects'
											limit={limit}
											resetPages={() => { }}
											action={actionTest}
											reducer={reducerSingleApplicationMultiSelect}
										/>
									</div>
								</th>
							</tr>
						</thead>

						<tbody>
							{data?.map((el: any, index: any) => (
								<tr className={clsx('active__link_tr', getRowClassName(el))} key={index}>
									<td>
										<input
											onChange={() => handleRowCheckboxChange(el)}
											checked={
												(isCheckedRows && isCheckedRows[el.application.id]) || false
											}
											className='relative__elem'
											type='checkbox'
										/>
									</td>
									<td>
										<span className='relative__elem'>{el?.lastName}</span>
									</td>
									{(claims.includes('admin') || claims.includes('projects:list')) && <td>
										<span className='relative__elem'>
											{el?.vacancyData?.project?.name}
										</span>
									</td>}
									<td>
									</td>
									<td>
										<span className='relative__elem'>
											{el.vacancyData?.vacancy?.name}
										</span>
									</td>
									<td>
									</td>
									<td>
										<span className='relative__elem'>
											{el.phone}
										</span>
									</td>
									<td>
										<span className='relative__elem'>
											{el.applicantStatus && Object.values(el.applicantStatus)[0]}
										</span>
									</td>
									<td>
										<span className='relative__elem'>{el?.applicantCondition}</span>
									</td>
									<td>
										<span className='relative__elem'>
											{el?.modifiedDate && formatDateWithDots(el?.modifiedDate)}
										</span>
									</td>
									<td>
									</td>
									<td className='invisible__reports_cell'>
										<a
											href={`${detectedBasename}/recruiting/applicationform/${el.application.id}`}
											className='link__tr'
											draggable='false'
											rel='noreferrer'
											target='_blank'
										>
											{' '}
										</a>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<div className='pagination'>
					<div className='pagination__count'>Всего: {count}</div>
					<div className='pagination__str'>
						<span>Отображать строки</span>
						<LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
					</div>
					<Pagination
						setCurrentPage={setCurrentPage}
						setStartPage={setStartPage}
						handleChange={handleChange}
						currentPage={currentPage}
						startPage={startPage}
						count={count}
						limit={actualLimit}
						pageName='userReports'
					/>
				</div>
			</div>
		</>
	);
};

export default TableApplicationFormList;
